export const getLastNQuarters = (n: number) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentQuarter = Math.floor(currentDate.getMonth() / 3) + 1;

    const quarters: [string, string][] = [];
    let year = currentYear;
    let quarter = currentQuarter;

    for (let i = 0; i < n; i++) {
        quarters.unshift([year.toString(), `Q${quarter}`]);
        quarter--;
        if (quarter === 0) {
            quarter = 4;
            year--;
        }
    }

    return quarters;
};

const monthAbbreviations = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

export const getLastNMonths = (n: number) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    let month = currentDate.getMonth() - 1;
    let year = currentYear;

    if (month === -1) {
        month = 11;
        year--;
    }

    const months: [string, string][] = [];

    for (let i = 0; i < n; i++) {
        months.unshift([year.toString(), monthAbbreviations[month]]);
        month--;
        if (month === -1) {
            month = 11;
            year--;
        }
    }

    return months;
};

const formatDate = (date) => {
    const options = {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    };
    return date.toLocaleString("en-US", options);
};

export const getYesterday = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    return formatDate(yesterday);
};

export const getToday = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return formatDate(today);
};

const currentDate = new Date();
const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "September",
    "October",
    "November",
    "December",
];
export const getCurrentMonth = () => monthNames[currentDate.getMonth()];
